var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ClientsView } from "./ui/view";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { person } from "../../store/person/actions";
import { columns, options } from "./resources/clientsDTO";
import { hasPermission } from "../../services/getNavigationPages";
import useUI from "./components/ui";
import useClients from "./components/clients";
import useSelectors from "./components/selectors";
export var ClientsPage = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var _c = React.useState(5000), limit = _c[0], setLimit = _c[1];
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    var _e = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _e[0], setSeeToast = _e[1];
    var handleClickSeeDetails = useUI(navigate).handleClickSeeDetails;
    var handleSearch = useClients(enable, page, limit).handleSearch;
    var _f = useSelectors(), responsePerson = _f.responsePerson, loadingPerson = _f.loadingPerson;
    useEffect(function () {
        dispatch(person({ enable: enable, page: page, limit: limit }));
    }, []);
    useEffect(function () {
        if (responsePerson) {
            setRows([]);
            responsePerson.map(function (item) {
                setRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                    {
                        id: item.id,
                        documentId: item.numberId,
                        fullName: item.lastNameA +
                            " " +
                            item.lastNameB +
                            ", " +
                            item.firstNameA +
                            " " +
                            item.firstNameB,
                        email: item.email,
                        phone: item.phone1,
                        dob: item.dob,
                    },
                ], false); });
            });
        }
    }, [responsePerson]);
    return (_jsx(React.Fragment, { children: _jsx(ClientsView, { title: "", columns: columns(handleClickSeeDetails, hasPermission), rows: rows, onClickSeeDetails: handleClickSeeDetails, onSearch: handleSearch, listIdentificationType: options }) }));
};
